const GA_MEASUREMENT_ID = 'G-60SM5GFJC0';

const isAnalyticsEnabled = () =>
  typeof window !== 'undefined' &&
  typeof window.gtag === 'function';

const sanitizeValue = (value) => {
  if (value == null) return undefined;
  if (Array.isArray(value)) {
    const items = value.map(sanitizeValue).filter(Boolean);
    return items.length ? items.join(', ') : undefined;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed || undefined;
  }
  return value;
};

const sanitizeParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params)
      .map(([key, value]) => [key, sanitizeValue(value)])
      .filter(([, value]) => value !== undefined)
  );

export const getAnalyticsEventDetails = (event) => {
  const venue = event?._embedded?.venues?.[0];
  const classifications = event?.classifications || [];

  return sanitizeParams({
    event_id: event?.id,
    event_name: event?.name,
    event_category: classifications[0]?.segment?.name,
    event_genre: classifications[0]?.genre?.name,
    venue_name: venue?.name,
    venue_city: venue?.city?.name,
    venue_state: venue?.state?.stateCode,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!isAnalyticsEnabled()) return;
  window.gtag('event', eventName, sanitizeParams(params));
};

export const trackPageView = (path) => {
  if (!isAnalyticsEnabled()) return;
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
  });
};

